import React from 'react'
import { Link } from "react-scroll";
import './navbar.css';
import ReactGA from 'react-ga';
const Navbar = () => {

  const handleClick = () => {
    ReactGA.event({ 'category': 'Resume', 'action': 'open', 'label': 'label' });
  }
  return (
    <div className="navbar navbar_fixed">
      <div className='navbar2 container '>
        <div className="navbarleft">
          <span>Nilesh</span>
        </div>
        <div className="navbarright">
          <ul className='navbaritem'>
            <Link smooth={true} duration={100} className="nav-link" to="home">Home</Link>
            <Link smooth={true} duration={100} className="nav-link" to="about">About</Link>
            <Link smooth={true} duration={100} className="nav-link" to="project">Project</Link>
            <a onClick={handleClick} href='https://drive.google.com/file/d/1AcEuySIau_5hV59v9wKZghtVIhCPGtQE/view' rel="noreferrer" target='_blank' className="nav-link" >Resume</a>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Navbar